import { h, Component } from 'preact';
import { Router, route } from 'preact-router';
import { ThemeProvider } from '@rmwc/theme'
import firebase from './firebase.js';

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import Header from './header';

// Code-splitting is automated for `routes` directory
import Home from '../routes/home';
import Login from '../routes/login';
import Profile from '../routes/profile';
import Facilities from '../routes/facilities';
import FacilitiesAdmin from '../routes/facilitiesadmin';
import UserSetup from '../routes/usersetup';
import UsersAdmin from '../routes/usersadmin';
import { ExternalLinks } from './externallinks';

import { SnackbarQueue } from '@rmwc/snackbar';
import '@rmwc/snackbar/styles';
import { DialogQueue } from '@rmwc/dialog';
import '@rmwc/dialog/styles';
import { Portal } from '@rmwc/base';
import { queue, dialogQueue } from './myQueue';

export default class App extends Component {

	handleRoute = e => {
		this.currentUrl = e.url;
		this.setState({currentUrl:this.currentUrl})
	};

	showRefreshSnack = () => {
		queue.notify({
			title: 'Site Updated, Refresh for a better experience'
		});
		  
	};

	PERMISSION={
		STUDENT:0,
		TEACHER:1,
		COMMITTEE:2,
		ADMIN:3,
		TERMINAL:4,
		SUPERGOD:5
	}

	componentDidMount(){
		if(typeof window !== 'undefined'){
			Sentry.init({
				dsn: "https://8303f0ddcab34170bd8ced45ad30b306@o411904.ingest.sentry.io/5655055",
				integrations: [new Integrations.BrowserTracing()],
				tracesSampleRate: 1.0,
			  });
			this.db = firebase.firestore();
			this.rtdb = firebase.database();
			this.analytics = firebase.analytics();
			if(firebase.messaging.isSupported()){
 				this.messaging = firebase.messaging();
			}
			this.setState({ userState: 'logging_in' });
			firebase.auth().onAuthStateChanged(currentUser=>{
				this.setState({ userState: 'completed_login', currentUser: currentUser });
				if(currentUser){
					if(firebase.messaging.isSupported()){
						this.messaging.getToken({vapidKey: "BN-bEsOdndXuLWsywOGEWXHrYAzhj7lIwrppqrxsSfYxyzLI98ul_s_mo5_S96d_M_UGq0cxHH1Im6QrMSb-U3c"}).then((currentToken) => {
						if (currentToken) {
							this.rtdb.ref(`notificationTokens/${currentUser.uid}/${currentToken}`).set(new Date().getTime())
							this. messaging.onMessage(({notification:notification}) => {
								console.log('Message received. ', notification);
								snackbarQueue.notify(notification)
							});
							  
						} else {
						  console.log('No registration token available. Request permission to generate one.');
						}
					  }).catch((err) => {
						console.log('An error occurred while retrieving token. ', err);
					  });
						this.messaging.onMessage((payload) => {
							console.log('Message received. ', payload);
							queue.notify(payload.notification);
						});
					}
					(async()=>{
						try {
							let idTokenResult= await currentUser.getIdTokenResult()
							console.log(idTokenResult.claims)
							this.setState({userClaims:idTokenResult.claims});
							if(typeof idTokenResult.claims.status != 'undefined' || (idTokenResult.claims.userGroup || [] ).includes("CEC_MEMBER")){
								if(this.currentUrl=='/setup' )route('/')
							} else {
								route('setup');
							}
						} catch (e){
							console.error(e);
						}
					})();
					

					this.rtdb.ref(`refreshtoken/${currentUser.uid}`).on('value',snap=>{
						if(snap.val()>0){
							this.rtdb.ref(`refreshtoken/${currentUser.uid}`).set(0);
							currentUser.getIdToken(true);
						}
					})
					this.detachUserFirestore = this.db.doc(`users/${currentUser.uid}`).onSnapshot(snapshot=>{
						const data = snapshot.data();
						this.setState({ userFirestore: data })
					})
				} else {
					if(this.detachUserFirestore)this.detachUserFirestore();				}
			})
		}
	}

	render ({},{currentUser,userClaims,userFirestore,currentUrl, userState}){
		return <ThemeProvider id="app" options={{
			primary: '#1565c0',
			secondary: '#e64a19',
			error: '#b00020',
			background: '#212121',
			surface: '#424242',
			onPrimary: 'rgba(255,255,255,.87)',
			onSecondary: 'rgba(0,0,0,0.87)',
			onSurface: 'rgba(255,255,255,.87)',
			onError: '#fff',
			textPrimaryOnBackground: 'rga(255,b 255, 255, 1)',
			textSecondaryOnBackground: 'rgba(255, 255, 255, 0.7)',
			textHintOnBackground: 'rgba(255, 255, 255, 0.5)',
			textDisabledOnBackground: 'rgba(255, 255, 255, 0.5)',
			textIconOnBackground: 'rgba(255, 255, 255, 0.5)',
			textPrimaryOnLight: 'rgba(0, 0, 0, 0.87)',
			textSecondaryOnLight: 'rgba(0, 0, 0, 0.54)',
			textHintOnLight: 'rgba(0, 0, 0, 0.38)',
			textDisabledOnLight: 'rgba(0, 0, 0, 0.38)',
			textIconOnLight: 'rgba(0, 0, 0, 0.38)',
			textPrimaryOnDark: 'white',
			textSecondaryOnDark: 'rgba(255, 255, 255, 0.7)',
			textHintOnDark: 'rgba(255, 255, 255, 0.5)',
			textDisabledOnDark: 'rgba(255, 255, 255, 0.5)',
			textIconOnDark: 'rgba(255, 255, 255, 0.5)'
		}}>
			<Header
				currentUrl={currentUrl}
				userFirestore={userFirestore}
				userClaims={userClaims}
				user={currentUser}
			/>
			<Router onChange={this.handleRoute}>
				<Home 
					path="/" 
					userClaims={userClaims}/>
				<Profile 
					path="/profile" 
					user={currentUser}
					userClaims={userClaims}
					userFirestore={userFirestore}
				/>
				{(userClaims && (userClaims.userGroup || []).includes('CEC_ADMIN')) &&<Profile 
					path="/profile/:id" 
					user={currentUser}
					userClaims={userClaims}
					userFirestore={userFirestore}
				/>}
				{(userClaims && (userClaims.userGroup || []).includes('CEC_MEMBER')) &&<Facilities 
					path="/facilities" 
					user={currentUser}
					userClaims={userClaims}
					userFirestore={userFirestore}
				/>}
				{(userClaims && (userClaims.userGroup || []).includes('CEC_ADMIN')) &&<FacilitiesAdmin 
					path="/admin/facilities" 
					user={currentUser}
					userClaims={userClaims}
					userFirestore={userFirestore}
				/>}
				<UserSetup 
					path="/setup" 
					user={currentUser}
					userClaims={userClaims}
					userFirestore={userFirestore}
					snackbar={this.snackbar}
					/>
				{(userClaims && (userClaims.userGroup || []).includes('CEC_ADMIN')) &&<UsersAdmin 
					path="/admin/users" 
					user={currentUser}
					userClaims={userClaims}
					userFirestore={userFirestore}
				/>}
				<ExternalLinks
					path="/link/:linkName"
				/>
			</Router>
			<SnackbarQueue
				messages={queue.messages}
				stacked
			/>
			<DialogQueue
				dialogs={dialogQueue.dialogs}
			/>
			<Portal />
		</ThemeProvider >
	}
}